import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ReasonService } from '../reason.service';
import * as reasonActions from './reason.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { User } from '../../../_models/user';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../../state/app.actions';
import * as fromRoot from '../../../state/app.reducer';
import { Reason } from '../../../_models/reason';
import { ReasonType } from '../../../_models/reason_type';

@Injectable()
export class ReasonEffects {

    @Effect()
    loadReason$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.LoadReasons),
        mergeMap((action: reasonActions.LoadReasons) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadReasons =');
                // console.log(action.payload);

                return this.reasonService.getReasons(action.payload).pipe(
                    map((reasons: Reason[]) => {
                        this.changingLoading(false);
                        return new reasonActions.LoadReasonsSuccess(reasons);
                    }),
                    catchError(err => of(new reasonActions.LoadReasonsFail(err)))
                );
            }
        )
    );

    @Effect()
    loadReasonTypes$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.LoadReasonTypes),
        mergeMap((action: reasonActions.LoadReasonTypes) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadReasons =');
                // console.log(action.payload);

                return this.reasonService.getReasonTypes(action.payload).pipe(
                    map((reasons: ReasonType[]) => {
                        this.changingLoading(false);
                        return new reasonActions.LoadReasonTypesSuccess(reasons);
                    }),
                    catchError(err => of(new reasonActions.LoadReasonTypesFail(err)))
                );
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadReasonSuccess$ = this.actions$.pipe(
    //     ofType(reasonActions.ReasonActitonTypes.LoadReasonsSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateReason$: Observable<Action> = this.actions$.pipe(
    //     ofType(reasonActions.ReasonActitonTypes.UpdateReason),
    //     map((action: reasonActions.UpdateReason) => action.payload),
    //     mergeMap(( reason: Reason) =>
    //         this.reasonService.updateReason(reason).pipe(
    //         map(updatedReason => (new reasonActions.UpdateReasonSuccess(updatedReason))),
    //         catchError(err => of(new reasonActions.UpdateReasonFail(err)))
    //     ))
    // );

    @Effect()
    updateReason$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.UpdateReason),
        mergeMap((action: reasonActions.UpdateReason) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateReason =');
                // console.log(action.payload);

                return this.reasonService.updateReason(action.payload).pipe(
                    map((reason: Reason) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateReason =');
                        console.log(reason);
                        if (reason !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/reason', null, 'info');
                            return new reasonActions.UpdateReasonSuccess(reason);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new reasonActions.UpdateReasonFail('ERROR UpdateReason effect.');
                        }
                    }),
                    catchError(err => of(new reasonActions.UpdateReasonFail(err)))
                );
            }
        )
    );

    @Effect()
    CreateReason$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.CreateReason),
        mergeMap((action: reasonActions.CreateReason) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateReason =');
                // console.log(action.payload);

                return this.reasonService.createReason(action.payload).pipe(
                    map((reason: Reason) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateReason =');
                        // console.log(reason);
                        if (reason !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/reason', null, 'info');
                            return new reasonActions.CreateReasonSuccess(reason);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new reasonActions.CreateReasonFail('ERROR CreateReason effect.');
                        }
                    }),
                    catchError(err => of(new reasonActions.CreateReasonFail(err)))
                );
            }
        )
    );

    @Effect()
    deleteReason$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.DeleteReason),
        mergeMap((action: reasonActions.DeleteReason) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteReason =');
                // console.log(action.payload);

                return this.reasonService.deleteReason(action.payload).pipe(
                    map((reasonId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteReason =');
                        console.log(reasonId);
                        if (reasonId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new reasonActions.DeleteReasonSuccess(reasonId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new reasonActions.DeleteReasonFail('ERROR DeleteReason effect.');
                        }
                    }),
                    catchError(err => of(new reasonActions.DeleteReasonFail(err)))
                );
            }
        )
    );

    @Effect()
    loadUsers$ = this.actions$.pipe(
        ofType(reasonActions.ReasonActitonTypes.LoadUsers),
        mergeMap((action: reasonActions.LoadUsers) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadUsers =');
                // console.log(action.payload);

                return this.reasonService.getUsers().pipe(
                    map((users: User[]) => {
                        this.changingLoading(false);
                        return new reasonActions.LoadUsersSuccess(users);
                    }),
                    catchError(err => of(new reasonActions.LoadUsersFail(err)))
                );
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private reasonService: ReasonService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Reason Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
